// extracted by mini-css-extract-plugin
module.exports = {"error-page":"style-module__error-page___cit7m","content":"style-module__content___265py","description":"style-module__description___331y0","anchor":"style-module__anchor___ThGky"};